// extracted by mini-css-extract-plugin
module.exports = {"quoteSlider":"quote-slider_quoteSlider__LWBpJ","largeMode":"quote-slider_largeMode__PHBwj","dark":"quote-slider_dark__L3XdK"};